import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SingleTabEditDialog, SingleTabEditDialogProps } from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditTimeTrackingActivityForm } from '../EditTimeTrackingActivityForm/EditTimeTrackingActivityForm';
export type EditTimeTrackingActivityDialogProps = PropsWithoutChildren<Omit<SingleTabEditDialogProps, 'tabTitle'>> & {
  timeTrackingActivity: TimeTrackingActivity;
};
export const EditTimeTrackingActivityDialog: FunctionComponent<EditTimeTrackingActivityDialogProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let timeTrackingActivity;
  if ($[2] !== t0) {
    ({
      timeTrackingActivity,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = timeTrackingActivity;
  } else {
    remainingProps = $[3];
    timeTrackingActivity = $[4];
  }
  const {
    t
  } = useTranslation();
  const handlePropertyChanged = useModifyEntityCallback(EntityName.TimeTrackingActivity);
  let t1;
  if ($[5] !== t) {
    t1 = t("components.timeTrackingActivity.EditTimeTrackingActivityDialog.title");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== handlePropertyChanged || $[8] !== timeTrackingActivity) {
    t2 = <EditTimeTrackingActivityForm timeTrackingActivity={timeTrackingActivity} onPropertyChanged={handlePropertyChanged} data-testid="EditTimeTrackingActivityDialog.Form" />;
    $[7] = handlePropertyChanged;
    $[8] = timeTrackingActivity;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== remainingProps || $[11] !== t1 || $[12] !== t2) {
    t3 = <SingleTabEditDialog {...remainingProps} tabTitle={t1}>{t2}</SingleTabEditDialog>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});